<template>
	<div class="omapi-campaign-settings__publishstatus-buttons">
		<button
			type="button"
			class="omapi-button omapi-button__wider omapi-button__steps"
			:class="{ 'omapi-button__blue': statusText === 'Draft' }"
			@click="onChangeStatus('Draft')"
		>
			Draft
		</button>
		<span>&#10141;</span>
		<button
			type="button"
			class="omapi-button omapi-button__wider omapi-button__steps"
			:class="{ 'omapi-button__blue': statusText === 'Pending' }"
			@click="onChangeStatus('Pending')"
		>
			Pending
		</button>
		<span>&#10141;</span>
		<button
			type="button"
			class="omapi-button omapi-button__wider omapi-button__steps"
			:class="{ 'omapi-button__blue': statusText === 'Published' }"
			@click="onChangeStatus('Published')"
		>
			{{ publishButtonText }}
		</button>
		<core-save-button
			color="green"
			:disabled="!changed"
			:saving="saving"
			class="omapi-button__save omapi-button__steps"
			@click="save"
		>
			Save
		</core-save-button>
	</div>
</template>

<script lang="js">
export default {
    props: {
        changed: Boolean,
        saving: Boolean,
        statusText: {
            type: String,
            default: '',
        },
    },
    computed: {
		publishButtonText () {
			if (true === this.changed) {
				return 'Publish'
			}
			return 'Published' === this.statusText ? 'Published' : 'Publish'
		},
	},
    methods: {
		onChangeStatus (status) {
			this.$emit('updateStatus', status)
		},
        save() {
            this.$emit('onSave');
        },
    },
};
</script>
